(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  class ZHotspots extends HTMLElement {
    connectedCallback() {
      this.spots = Array.prototype.slice.call(this.querySelectorAll('.zhs__spot'));
      if (!this.spots.length) return;

      var self = this;
      this.spots.forEach(function (spot) {
        var btn = spot.querySelector('.zhs__dot');
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          self.toggle(spot);
        });
      });

      this._onDocClick = function (e) {
        if (!e.target.closest('.zhs__spot') || !self.contains(e.target)) self.closeAll();
      };
      this._onKey = function (e) {
        if (e.key === 'Escape') self.closeAll();
      };
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onKey);
    }

    toggle(spot) {
      var isOpen = spot.classList.contains('is-open');
      this.closeAll();
      if (!isOpen) {
        spot.classList.add('is-open');
        var btn = spot.querySelector('.zhs__dot');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }
    }

    closeAll() {
      this.spots.forEach(function (s) {
        s.classList.remove('is-open');
        var btn = s.querySelector('.zhs__dot');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (!customElements.get('z-hotspots')) {
    customElements.define('z-hotspots', ZHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.imgcard');
    if (!card) return;
    var toggle = card.querySelector('.imgcard__media--toggle');
    if (!toggle) return; // card has no description to reveal
    var open = toggle.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  class UgcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ugc-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ugc-slide]'));
      this.rotate = this.dataset.rotate === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.manualPaused = new WeakSet();
      this.unmuted = null;
      this.drag = { active: false, startX: 0, startScroll: 0, moved: false, target: null };

      var self = this;
      this.slides.forEach(function (s) { self.setupSlide(s); });

      this.track.addEventListener('pointerdown', this.onDown.bind(this));
      this.track.addEventListener('pointermove', this.onMove.bind(this));
      this.track.addEventListener('pointerup', this.onUp.bind(this));
      this.track.addEventListener('pointercancel', this.onUp.bind(this));
      this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      this.track.addEventListener('scroll', this.debounce(function () { self.updateActive(); }, 120), { passive: true });

      this.addEventListener('mouseenter', function () { self.stopRotate(); });
      this.addEventListener('mouseleave', function () { if (!self.unmuted) self.startRotate(); });
      window.addEventListener('resize', this.debounce(function () { self.updateActive(); }, 150));

      this.updateActive();
      this.startRotate();
    }

    disconnectedCallback() { this.stopRotate(); }

    setupSlide(slide) {
      var self = this;
      var v = slide.querySelector('[data-ugc-video]');
      if (!v) return;
      v.muted = true;
      slide.classList.add('is-paused');
      var muteBtn = slide.querySelector('[data-ugc-mute]');
      var playBtn = slide.querySelector('[data-ugc-play]');
      if (muteBtn) muteBtn.addEventListener('click', function (e) { e.stopPropagation(); self.toggleMute(slide, v); });
      if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); self.clickToggle(slide, v); });
      v.addEventListener('play', function () { slide.classList.remove('is-paused'); });
      v.addEventListener('pause', function () { slide.classList.add('is-paused'); });
    }

    /* The slide whose centre is nearest the viewport centre */
    activeSlide() {
      var r = this.track.getBoundingClientRect();
      var center = r.left + r.width / 2;
      var best = null, bestD = Infinity;
      this.slides.forEach(function (s) {
        var sr = s.getBoundingClientRect();
        var d = Math.abs(sr.left + sr.width / 2 - center);
        if (d < bestD) { bestD = d; best = s; }
      });
      return best;
    }

    updateActive() {
      var active = this.activeSlide();
      var self = this;
      this.slides.forEach(function (s) {
        var v = s.querySelector('[data-ugc-video]');
        if (!v) return;
        if (s === active) {
          if (!self.manualPaused.has(v)) v.play().catch(function () {});
        } else {
          v.pause();
          self.manualPaused.delete(v);
          if (self.unmuted === v) { v.muted = true; s.classList.remove('is-unmuted'); self.unmuted = null; self.startRotate(); }
        }
      });
    }

    onDown(e) {
      if (e.target.closest('[data-ugc-mute],[data-ugc-play]')) return; // let controls handle their own clicks
      this.drag.active = true;
      this.drag.startX = e.clientX;
      this.drag.startScroll = this.track.scrollLeft;
      this.drag.moved = false;
      this.drag.target = e.target;
      this.classList.add('is-dragging');
      this.track.style.scrollSnapType = 'none';
      this.stopRotate();
      if (this.track.setPointerCapture) { try { this.track.setPointerCapture(e.pointerId); } catch (err) {} }
    }

    onMove(e) {
      if (!this.drag.active) return;
      var dx = e.clientX - this.drag.startX;
      if (Math.abs(dx) > 6) this.drag.moved = true;
      this.track.scrollLeft = this.drag.startScroll - dx;
    }

    onUp() {
      if (!this.drag.active) return;
      this.drag.active = false;
      this.classList.remove('is-dragging');
      this.track.style.scrollSnapType = '';
      if (this.drag.moved) {
        this.snapNearest();
      } else if (!this.drag.target.closest('[data-ugc-mute],[data-ugc-play]')) {
        var slide = this.drag.target.closest('[data-ugc-slide]');
        if (slide) {
          var v = slide.querySelector('[data-ugc-video]');
          if (v) this.clickToggle(slide, v);
        }
      }
      if (!this.unmuted) this.startRotate();
    }

    clickToggle(slide, v) {
      var self = this;
      if (v.paused) {
        this.slides.forEach(function (s) {
          var o = s.querySelector('[data-ugc-video]');
          if (o && o !== v) { o.pause(); self.manualPaused.delete(o); }
        });
        this.manualPaused.delete(v);
        v.play().catch(function () {});
      } else {
        this.manualPaused.add(v);
        v.pause();
      }
    }

    snapNearest() {
      var self = this;
      var trackLeft = this.track.getBoundingClientRect().left;
      var sl = this.track.scrollLeft;
      var bestRel = 0, bestD = Infinity;
      this.slides.forEach(function (s) {
        var rel = s.getBoundingClientRect().left - trackLeft + self.track.scrollLeft;
        var d = Math.abs(rel - sl);
        if (d < bestD) { bestD = d; bestRel = rel; }
      });
      this.track.scrollTo({ left: bestRel, behavior: this.reduced ? 'auto' : 'smooth' });
      setTimeout(function () { self.updateActive(); }, 320);
    }

    toggleMute(slide, v) {
      var self = this;
      if (v.muted) {
        this.slides.forEach(function (s) {
          var o = s.querySelector('[data-ugc-video]');
          if (o && o !== v) { o.muted = true; s.classList.remove('is-unmuted'); }
        });
        v.muted = false;
        slide.classList.add('is-unmuted');
        this.unmuted = v;
        this.stopRotate();
        v.play().catch(function () {});
      } else {
        v.muted = true;
        slide.classList.remove('is-unmuted');
        this.unmuted = null;
        this.startRotate();
      }
    }

    startRotate() {
      if (!this.rotate || this.reduced) return;
      this.stopRotate();
      var self = this;
      this.timer = setInterval(function () { self.advance(); }, this.interval);
    }

    stopRotate() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }

    advance() {
      var slide = this.slides[0];
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      var step = slide.getBoundingClientRect().width + gap;
      var self = this;
      if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: step, behavior: 'smooth' });
      }
      setTimeout(function () { self.updateActive(); }, 420);
    }

    debounce(fn, ms) {
      var t;
      return function () { clearTimeout(t); t = setTimeout(fn, ms); };
    }
  }

  if (!customElements.get('ugc-carousel')) {
    customElements.define('ugc-carousel', UgcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onClick(e) {
      var trigger = e.target.closest('[data-hero-scroll]');
      if (!trigger) return;
      e.preventDefault();
      var id = trigger.getAttribute('data-target');
      var target = id ? document.getElementById(id) : null;
      if (!target) {
        var section = trigger.closest('.shopify-section');
        target = section ? section.nextElementSibling : null;
      }
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    document.addEventListener('click', onClick);
  })();

  } catch(e) { console.error(e); }
})();
})();
